import React from 'react';
import { Gauge } from 'lucide-react';
export function PressureControlSection() {
  return <section className="py-16 bg-white border-b border-gray-100" data-id="element-756">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-757">
        <div className="flex flex-col md:flex-row items-start gap-8" data-id="element-758">
          <div className="flex-shrink-0" data-id="element-759">
            <div className="w-16 h-16 bg-brand-yellow/10 rounded-full flex items-center justify-center" data-id="element-760">
              <Gauge className="h-8 w-8 text-brand-yellow" data-id="element-761" />
            </div>
          </div>
          <div data-id="element-762">
            <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-763">
              Automatic Pressure Control (60 PSI)
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-764">
              The ForceX system automatically builds pressure up to 60 PSI and
              then shuts off. When the spray trigger is squeezed, pressure is
              released and the pump automatically reactivates to restore
              pressure on demand. This ensures consistent spray performance,
              prevents over-pressurization, and reduces wear on the system.
            </p>
          </div>
        </div>
      </div>
    </section>;
}